import React from "react";

import { Divider as AntDivider, DividerProps as AntDividerProps } from "antd";

export type DividerProps = AntDividerProps & {
  color?: string;
  dotted?: boolean; // Todo: Remove after updating AntDesign and use the 'variant' property
};

export const Divider = ({ color, dotted, ...props }: DividerProps) => (
  <AntDivider {...props} className={`${props.className}  ${dotted && "dotted"}`} style={{ ...props.style, borderColor: color }} />
);

export default Divider;
